import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";

interface InvalidPolygonAlertProps {
  t: (key: string) => string;
}

export function InvalidGeofenceAlert({ t }: InvalidPolygonAlertProps) {
  return (
    <Alert rounded="base" status="warning" color="gray.700">
      <AlertIcon />
      <AlertDescription lineHeight={"20px"} fontSize={"small"}>
        {t("invalidArea")}
      </AlertDescription>
    </Alert>
  );
}
